import { render, staticRenderFns } from "./CandidateEmail.vue?vue&type=template&id=94ac6054&scoped=true&lang=pug"
import script from "./CandidateEmail.vue?vue&type=script&lang=js"
export * from "./CandidateEmail.vue?vue&type=script&lang=js"
import style0 from "./CandidateEmail.vue?vue&type=style&index=0&id=94ac6054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac6054",
  null
  
)

export default component.exports